<template>
  <div>
    <section>
        <div class="flex-row flex-justify-center section-container">
            <div class="flex-column flex-item-center flex-grow single-news-wrapper">
                <card class="news-card neutral no-padding">
                    <template #image>
                        <img :src="coverImg"/>
                    </template>
                    <div v-html="articleBody">
                    </div>
                </card>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
import strapiServices from '../services/StrapiServices';
import strapiMixins from "../utilities/strapiMixins";
import markdownit from 'markdown-it'

export default {
  components: {

  },
  mixins: [strapiMixins],
  data() {
    return {
        articleBody: "",
        coverImg: "",
    };
  },
  created () {
    
  },
  mounted() {
    this.getNewsById();
  },
  filters: {
    
  },
  computed: {

  },
  methods: {
    async getNewsById() {
        try {
            let response = await strapiServices.GET_STRAPI("news-articles/" + this.$route.params.articleId);
            let articles = response.data;

            this.newsArticles = articles;
            const md = markdownit()
            const result = md.render(this.newsArticles.mainContent);
            this.articleBody = result;

            if (this.mainUrl) {
              var tmpObj=document.createElement("div");
              tmpObj.innerHTML=this.articleBody;
              tmpObj.querySelectorAll('img').forEach((imgEl) => {
                let oldURL = imgEl.src;
                let newUrl = this.mainUrl + oldURL.replace(/^.*\/\/[^\/]+/, '');
                imgEl.src = newUrl;
              });

              this.articleBody = tmpObj.innerHTML;
              this.coverImg = this.mainUrl + this.newsArticles.coverImg.url.replace(/^.*\/\/[^\/]+/, '');
            } else {
              this.coverImg = this.newsArticles.coverImg;
            }
        } catch (err) {
            console.log(err);
        }
    }
  }
};</script>
<style lang="scss">
</style>
